// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

/**
 * AlarmGroupDeleteDialog - Dialog for confirming alarm group deletion
 *
 * Displays group details and requires confirmation before deletion.
 */
const DeleteAlarmGroupDialog = ({
  open = false,
  groupToDelete,
  users = [],
  alarmTypes = [],
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('alarms');

  if (!groupToDelete) return null;

  console.log('Alarm Types in Delete Dialog:', alarmTypes);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('dialog.delete_alarm_group_title')}: {groupToDelete.Name}
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1" mb={2}>
          {t('dialog.delete_confirmation')}{' '}
          <strong>{groupToDelete.Name}</strong>? {t('dialog.delete_warning')}
        </Typography>

        <Box mb={2}>
          <Typography variant="subtitle2" gutterBottom>
            {t('dialog.users_in_group')}
          </Typography>
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {groupToDelete.AlarmSubscriptions.map((sub) => {
              const user = users.find((u) => u.User.UserId === sub.User.UserId);
              return (
                <Chip
                  key={sub.User.UserId}
                  label={user?.User?.Email || t('dialog.unknown_user')}
                  size="small"
                />
              );
            })}
          </Stack>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" gutterBottom>
            {t('dialog.included_alarm_types')}
          </Typography>
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {alarmTypes
              .filter((type) =>
                groupToDelete.AlarmInclusions.some(
                  (inclusion) =>
                    inclusion.AlarmType.AlarmTypeId === type.alarmTypeId,
                ),
              )
              .map((type) => (
                <Chip key={type.alarmTypeId} label={type.name} size="small" />
              ))}
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          {t('form.cancel')}
        </Button>
        <Button variant="contained" onClick={onConfirm} color="error">
          {t('dialog.delete_alarm_group')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAlarmGroupDialog;
